module.exports = __webpack_public_path__ + "img/A2_6.604345c5.png";